"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
function default_1() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: [`■ ${i18next_1.default.t('타입 안내')}`, (0, jsx_runtime_1.jsx)("br", {}), "\u2460", (0, jsx_runtime_1.jsx)("br", {}), "\u2461", (0, jsx_runtime_1.jsx)("br", {}), "\u2462", (0, jsx_runtime_1.jsx)("br", {}), "\u2463", (0, jsx_runtime_1.jsx)("br", {}), "\u2464"] }), (0, jsx_runtime_1.jsx)("p", { children: "\u00A0" }), (0, jsx_runtime_1.jsx)("p", { children: `■ ${i18next_1.default.t('추가금 옵션')}` })] }));
}
exports.default = default_1;
